import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ecaac20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*编号:")
  ])
], -1))
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*标题:")
  ])
], -1))
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "介绍:")
  ])
], -1))
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "适应人群:")
  ])
], -1))
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "分组:")
  ])
], -1))
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "分类:")
  ])
], -1))
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*价格:")
  ])
], -1))
const _hoisted_25 = { class: "mb-1 flex-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "体验价:")
  ])
], -1))
const _hoisted_27 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_28 = { class: "ml-2" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "闲时价:")
  ])
], -1))
const _hoisted_31 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_32 = { class: "ml-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "疗程价:")
  ])
], -1))
const _hoisted_34 = { class: "mb-1 flex-row" }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "疗程价2:")
  ])
], -1))
const _hoisted_37 = { class: "mb-1 flex-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-top" }, [
  /*#__PURE__*/_createElementVNode("label", null, "手工费:")
], -1))
const _hoisted_39 = { class: "mb-1" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { key: 4 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "设备时长:")
  ])
], -1))
const _hoisted_43 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "总时长:")
  ])
], -1))
const _hoisted_45 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "备注:")
  ])
], -1))
const _hoisted_47 = { class: "mb-1 flex-row flex-align-center" }
const _hoisted_48 = { key: 5 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "技师:")
  ])
], -1))
const _hoisted_50 = { class: "mb-1 flex-row" }
const _hoisted_51 = ["src", "onClick"]
const _hoisted_52 = { class: "flex-row-center mr-3" }
const _hoisted_53 = { key: 6 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "仪器:")
  ])
], -1))
const _hoisted_55 = { class: "mb-1 flex-row" }
const _hoisted_56 = ["src", "onClick"]
const _hoisted_57 = { class: "flex-row-center mr-3" }
const _hoisted_58 = { key: 7 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "项目明细:")
  ])
], -1))
const _hoisted_60 = { class: "mb-1 flex-row" }
const _hoisted_61 = ["src", "onClick"]
const _hoisted_62 = { class: "mb-1" }
const _hoisted_63 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploader = _resolveComponent("ImageUploader")!
  const _component_PickEmployee = _resolveComponent("PickEmployee")!
  const _component_PickPreset = _resolveComponent("PickPreset")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.id ? '编辑' : '添加'), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                class: "modal-header-close"
              }, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.no) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.no]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.title]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.content) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.content]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.fit) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.fit]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.group) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.group]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.chankangType) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.item.chankangType]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_24,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        style: {"width":"120px"},
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.price) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.price]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: {"width":"120px"},
                        class: "form-control ml-2",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.unit) = $event)),
                        placeholder: "单位"
                      }, null, 512), [
                        [_vModelText, _ctx.item.unit]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        style: {"width":"120px"},
                        class: "form-control",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.trialPrice) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.trialPrice]
                      ]),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.item.unit), 1)
                    ])
                  ])
                ]),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            style: {"width":"120px"},
                            class: "form-control",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.idlePrice) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.idlePrice]
                          ]),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.item.unit), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_33,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        style: {"width":"120px"},
                        class: "form-control",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.packPrice) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.packPrice]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: {"width":"120px"},
                        class: "form-control ml-2",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.packUnit) = $event)),
                        placeholder: "单位"
                      }, null, 512), [
                        [_vModelText, _ctx.item.packUnit]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            style: {"width":"120px"},
                            class: "form-control",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.packPrice2) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.packPrice2]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            style: {"width":"120px"},
                            class: "form-control ml-2",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.packUnit2) = $event)),
                            placeholder: "单位"
                          }, null, 512), [
                            [_vModelText, _ctx.item.packUnit2]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_38,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.shopShougongList, (value, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "mb-1 flex-row",
                          key: idx
                        }, [
                          _createElementVNode("label", null, _toDisplayString(value.name), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            style: {"width":"120px"},
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((value.shougong) = $event)
                          }, null, 8, _hoisted_40), [
                            [_vModelText, value.shougong]
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (!_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_43, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            style: {"width":"120px"},
                            class: "form-control",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.deviceTime) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.deviceTime]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_44,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: {"width":"120px"},
                        class: "form-control",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.duration) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.duration]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_46,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.item.remark) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.remark]
                      ])
                    ])
                  ])
                ]),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.operator, (op, idx) => {
                            return (_openBlock(), _createElementBlock("div", { key: idx }, [
                              _createElementVNode("img", {
                                src: op.headimg,
                                class: "image-preview-small",
                                onClick: ($event: any) => (_ctx.item.operator.splice(idx,1))
                              }, null, 8, _hoisted_51),
                              _createElementVNode("div", _hoisted_52, _toDisplayString(op.name), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("img", {
                            src: "/assets/image_preview_add.png",
                            class: "image-preview-small",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPickEmployee=true))
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.device, (op, idx) => {
                            return (_openBlock(), _createElementBlock("div", { key: idx }, [
                              _createElementVNode("img", {
                                src: op.image,
                                class: "image-preview-small",
                                onClick: ($event: any) => (_ctx.item.device.splice(idx,1))
                              }, null, 8, _hoisted_56),
                              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.shortenTitle(op.title, 6)), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("img", {
                            src: "/assets/image_preview_add.png",
                            class: "image-preview-small",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showPickDevice=true))
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBlue)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_60, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.detail, (img, idx) => {
                            return (_openBlock(), _createElementBlock("div", { key: idx }, [
                              _createElementVNode("img", {
                                src: img,
                                style: {"width":"150px","height":"150px","cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.item.detail.splice(idx,1))
                              }, null, 8, _hoisted_61)
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_ImageUploader, { onUpload: _ctx.imageUpload }, null, 8, ["onUpload"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
              }, "确定")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPickEmployee)
      ? (_openBlock(), _createBlock(_component_PickEmployee, {
          key: 1,
          onCancel: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showPickEmployee=false)),
          onConfirm: _ctx.addOperator,
          shop: _ctx.item.shop,
          job: "美容师"
        }, null, 8, ["onConfirm", "shop"]))
      : _createCommentVNode("", true),
    (_ctx.showPickDevice)
      ? (_openBlock(), _createBlock(_component_PickPreset, {
          key: 2,
          onCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showPickDevice=false)),
          onConfirm: _ctx.addDevice,
          shop: _ctx.item.shop
        }, null, 8, ["onConfirm", "shop"]))
      : _createCommentVNode("", true)
  ], 64))
}